export const TOGGLE_SLIDESHOW_VISIBLE  = 'TOGGLE_SLIDESHOW_VISIBLE';
export const CHANGE_SLIDE              = 'CHANGE_SLIDE';
export const TOGGLE_COMMENTS_VISIBLE   = 'TOGGLE_COMMENTS_VISIBLE';
export const SET_COMMENTS_VISIBLE      = 'SET_COMMENTS_VISIBLE';
export const SET_COMMENT_PADDING       = 'SET_COMMENT_PADDING';
export const SET_OVERLAY_AD_VISIBLE    = 'SET_OVERLAY_AD_VISIBLE';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/constants.es6